import { CanActivateFn } from '@angular/router';
import { permissionGuard } from './permission.guard';

export const dashboardPermissionGuard: CanActivateFn = permissionGuard('CanReadDashboard');
